<template>
   <div class="header-menu-component d-flex justify-end align-center"> 
       <div class="menu-icon-container justify-end mr-10">
        <v-sheet style="margin: auto;" class="bg-transparent ml-0 pt-2">  <img @click="openMenu" class="btn-img" width="34" src="/icons/main-menu.png" /> </v-sheet>
      </div>
   </div>
    <div class="side-menu" :class="{ open: isOpen }">
      <div class="container-side-menu-elements">
         <div class="header-menu-component d-flex justify-end align-center"> 
            <div class="menu-icon-container justify-end mr-10">
               <v-sheet style="margin: auto;" class="bg-transparent ml-0 pt-2">  <img @click="openMenu" class="btn-img" width="34" src="/icons/main-menu-black.png" /> </v-sheet>
            </div>
         </div>
         <div class="header-menu-component menu-titles-container d-flex justify-center align-center"> 
             <ul>
               <li @click="go('what-new')" >WHAT'S NEW</li>
               <li @click="go('about')" >ABOUT</li>
               <li @click="go('contact')">CONTATC</li>
            </ul> 
         </div>
        
       
      </div>
   </div>
      
</template>
  
  
<script>


  
export default {
    name: "HeaderMenu",
    components : {
    },

   props: {
      onNavigate: Function
   },
    data: () => ({
      isOpen: false
    }),
    async mounted() {

    },
     methods: {
      go(section) {
      this.onNavigate(section);
      this.isOpen = false; 
   },
      async openMenu(){
       this.isOpen = !this.isOpen
      }
  
    },
 };

</script>

<style>
   .header-menu-component{
      width: 100%;
      background-color: rgb(0, 0, 0, 0) !important;
     
   }

   .menu-icon-container{
      cursor: pointer;
      margin-bottom: 10px;
   }

   .container-side-menu-elements{
      height: 100%;
      width: 100%;
      z-index: 6;
   }

   .side-menu {
    z-index: 5;
    position: fixed;
    top: 0;
    right: 0;
    width: 1200px;
    height: 100vh;
    background: white;
    color: black;
    border: 2px black;
    transform: translateX(100%);
    transition: transform 0.5s ease;


    clip-path: polygon(
      45% 0%,
      100% 0%,
      100% 100%,
      60% 100%,
      75% 65%,
      55% 65%,
      70% 35%,
      50% 35%
   );

    display: flex;
    align-items: center;
    justify-content: center;
}

.side-menu.open {
    transform: translateX(0);
}

.side-menu ul {
    list-style: none;
    padding: 0;
}

.menu-titles-container{
   margin-left: 74%;
   width: 25%;
}

.side-menu li {
    color: black;
    margin: 50px 0;
    font-size: 50px;
    font-weight: bolder;
    font-family: 'Poppins', sans-serif !important;
    cursor: pointer;
    transition: 0.3s;
}

.side-menu li:hover {
    transform: translateX(-10px);
}


</style>
    